import apiCustomInvoices from './../../api/apiCustomInvoices'
import apiInvoiceContactDetails from './../../api/apiInvoiceContactDetails'

const state = {
    errorStatus: false,
    errorMessage: null,
    isLoading: false,
    customInvoice: {
        id: null,
        user_id: null,
        invoice_details_id: null,
        condition: null,
        currency: null,
        remarks: null,
        name: null,
        commission: null,
        inland_transport: null,
        result: null,
        issued_date: null,
        due_date: null,
        balance_due_usd: null,
        paid_amount: null,
        sub_total: null,
        deposit_applied: null,
        balance_due: null,
        shipping_type: null,
        incoterm: null,
        rate: null
    },
    isModalActive: false,
    activeModalInvoiceId: null,
    contactDetails: []
}

const getters = {
    getCustomInvoice: (state) => {
        return state.customInvoice
    },
    getCustomInvoiceModalStatus: (state) => {
        return state.isModalActive
    },
    getCustomInvoiceErrorStatus: (state) => {
        return state.errorStatus
    },
    getCustomInvoiceErrorMessage: (state) => {
        return state.errorMessage
    },
    getCustomInvoiceLoadingStatus: (state) => {
        return state.isLoading
    },
    getCustomInvoiceQuery: (state) => {
        return state.query
    },
    getActiveModalCustomInvoiceId: (state) => {
        return state.activeModalInvoiceId
    },
    getCustomInvoiceContactDetails: (state) => {
        return state.contactDetails
    }
}

const mutations = {
    setCustomInvoice: (state, newCustom) => {
        state.customInvoice = newCustom
    },
    setCustomInvoiceFieldValue: (state, data) => {
        state.customInvoice[data.field] = data.value
    },
    setCustomInvoiceModalStatus: (state, newStatus) => {
        state.isModalActive = newStatus.status
        state.activeModalInvoiceId = newStatus.invoice_id
    },
    setCustomInvoiceErrorStatus: (state, newStatus) => {
        state.errorStatus = newStatus
    },
    setCustomInvoiceErrorMessage: (state, newMessage) => {
        state.errorMessage = newMessage
    },
    setCustomInvoiceQueryFieldValue: (state, data) => {
        state.query[data.field] = data.value
    },
    setCustomInvoiceContactDetails: (state, value) => {
        let list = []

        value.forEach(function(element) {
            list.push({
                value: element.id,
                text: element.name
            })
        })

        state.contactDetails = list
    },
    setCustomInvoiceToDefault: (state) => {
        state.customInvoice = {
            id: null,
            user_id: null,
            invoice_details_id: null,
            condition: null,
            currency: null,
            remarks: null,
            name: null,
            commission: null,
            inland_transport: null,
            result: null,
            issued_date: null,
            due_date: null,
            balance_due_usd: null,
            paid_amount: null,
            sub_total: null,
            deposit_applied: null,
            balance_due: null,
            shipping_type: null,
            incoterm: null,
            rate: null
        }
    },
    setCustomInvoiceQueryToDefault: (state) => {
        state.query = {
            car_id: null,
            shipping_type: null,
            invoice_details_id: null
        }
    }
}

const actions = {
    calculateCustomInvoice: ({ commit, state, getters }) => {
        let subTotal = Number(getters.getCustomInvoiceTotalSaleAmount)
        let balanceDue = Number(subTotal) - Number(state.customInvoice.deposit_applied)
        let profit = Number(subTotal) - Number(getters.getCustomInvoiceTotalCostAmount)
        let cost = Number(getters.getCustomInvoiceTotalCostAmount)
        commit('setCustomInvoiceFieldValue', { field: 'cost', value: cost })
        commit('setCustomInvoiceFieldValue', { field: 'sub_total', value: subTotal })
        commit('setCustomInvoiceFieldValue', { field: 'sales', value: subTotal })
        commit('setCustomInvoiceFieldValue', { field: 'balance_due', value: balanceDue })
        commit('setCustomInvoiceFieldValue', { field: 'profit', value: profit })
    },
    changeCustomInvoiceModalStatus: ({ commit }, newStatus) => {
        commit('setCustomInvoiceModalStatus', newStatus)
    },
    changeCustomInvoiceFieldValue: ({ commit }, newValue) => {
        commit('setCustomInvoiceFieldValue', newValue)
    },
    changeCustomInvoiceToDefault: ({ commit }) => {
        commit('setCustomInvoiceToDefault')
    },
    changeCustomInvoiceQueryToDefault: ({ commit }) => {
        commit('setCustomInvoiceQueryToDefault')
    },
    changeCustomInvoiceQueryFieldValue: ({ commit }, newValue) => {
        commit('setCustomInvoiceQueryFieldValue', newValue)
    },
    checkCustomInvoice: ({ commit }, carId) => {
        commit('setCustomInvoiceErrorStatus', true)
        apiCustomInvoices
            .checkCustomInvoiceRequirements(carId)
            .then((response) => {
                commit('setCustomInvoiceErrorStatus', false)
            })
            .catch((error) => {
                commit('setCustomInvoiceErrorStatus', true)
                commit('setCustomInvoiceErrorMessage', error.response.data)
            })
    },
    fetchCustomInvoice: ({ commit , dispatch}, carId) => {
        commit('setCustomInvoiceErrorStatus', true)
        commit('setCustomInvoiceErrorMessage', null)
        apiCustomInvoices
            .customInvoiceRequest(carId)
            .then((response) => {
                commit('setCustomInvoice', response.data)
                dispatch('changeCustomInvoiceCostItems', response.data.costs)
                dispatch('changeCustomInvoiceSaleItems', response.data.sales)
                dispatch('changeCustomInvoiceTotalSaleAmount')
                dispatch('changeCustomInvoiceTotalCostAmount')
                commit('setCustomInvoiceErrorStatus', false)
            })
            .catch((error) => {
                console.log(error)
                commit('setCustomInvoiceErrorMessage', error.response.data)
            })
    },
    createCustomInvoice: ({state, dispatch, commit}) => {
        apiCustomInvoices
            .createNewCustomInvoice(state.query)
            .then((response) => {
                commit('setCustomInvoice', response.data)
                dispatch('changeCustomInvoiceCostItems', response.data.costs)
                dispatch('changeCustomInvoiceSaleItems', response.data.sales)
                dispatch('changeCustomInvoiceTotalSaleAmount')
                dispatch('changeCustomInvoiceTotalCostAmount')
            })
            .catch((error) => console.log(error))

    },
    saveCustomInvoice: ({ state, getters }) => {
        let data = {
            id: state.customInvoice.id,
            customInvoice: state.customInvoice,
            cost_items: getters.getCustomInvoiceCostItems,
            sale_items: getters.getCustomInvoiceSaleItems
        }
        apiCustomInvoices
            .updateCustomInvoiceRequest(data)
            .then((response) => {

            })
            .catch((error) => console.log(error))
    },
    downloadCustomInvoicePdf: ({ state })  => {
        apiCustomInvoices
            .customInvoiceExportInPDFRequest(state.customInvoice.id)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                const name = Number(state.customInvoice.id).toString().padStart(6, 0)
                link.setAttribute('download', 'INV-'+ name + '.pdf')
                document.body.appendChild(link)
                link.click()
            })
            .catch((error) => console.log(error))
    },
    downloadCustomInvoiceExcel: ({ state })  => {
        apiCustomInvoices
            .customInvoiceExportInEXCELRequest(state.customInvoice.id)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]), {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
                const link = document.createElement('a')
                link.href = url
                const name = Number(state.customInvoice.id).toString().padStart(6, 0)
                link.setAttribute('download', 'INV-'+ name + '.xlsx')
                document.body.appendChild(link)
                link.click()
            })
            .catch((error) => console.log(error))
    },
    fetchCustomInvoiceContactDetails: ({ commit }, userId) => {
        apiInvoiceContactDetails
            .invoiceContactDetailsListRequest(userId)
            .then((response) => {
                commit('setCustomInvoiceContactDetails', response.data)
            })
            .catch((error) => console.log(error))
    }
}


export default { state, getters, mutations, actions }




// WEBPACK FOOTER //
// ./src/store/modules/customInvoice.js